"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserServiceContractActionEnum = void 0;
var UserServiceContractActionEnum;
(function (UserServiceContractActionEnum) {
  /** Могу купить занятия/серию занятий */
  UserServiceContractActionEnum["signup"] = "signup";
  /** Могу подписаться на занятия/серию занятий */
  UserServiceContractActionEnum["subscribe"] = "subscribe";
  /** Могу разорвать контракт */
  UserServiceContractActionEnum["break"] = "break";
  /** Могу отменить контракт */
  UserServiceContractActionEnum["cancel"] = "cancel";
  /**
   * Настроить оплату контракта
   *
   * @deprecated
   */
  UserServiceContractActionEnum["setup_payments"] = "setup_payments";
})(UserServiceContractActionEnum = exports.UserServiceContractActionEnum || (exports.UserServiceContractActionEnum = {}));
